import React from 'react';
import { motion } from 'framer-motion';
import { Anchor } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  isMain?: boolean;
}
export function CTAButton({
  text = '🚀 DESCARGAR AHORA',
  className = '',
  isMain = false
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (isMain) return; // Let the anchor tag handle it if it's the main button
    e.preventDefault();
    const target = document.getElementById('comprar');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const buttonClasses = `group relative inline-flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white font-heading font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] hover:shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto ${className}`;
  if (isMain) {
    return <motion.a href="https://checkout.librofy.online/cart/53040448274795:1" className={buttonClasses} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-23">
        {text}
      </motion.a>;
  }
  return <motion.button onClick={handleClick} className={buttonClasses} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-24">
      {text}
    </motion.button>;
}